/**
 * Auth utility functions
 * Note: Local password storage has been decommissioned for security.
 * We now rely on secure backend authentication and session tokens.
 */

export function setLocalPassword(customerId: number, _password: string): void {
  // Previously stored salt/hash here. Now we just ensure the customerId is known.
  localStorage.setItem("lastSessionCustomerId", customerId.toString());
}

export function verifyLocalPassword(_customerId: number, _password: string): boolean {
  // Local verification is disabled for security.
  // Login now requires a live connection to our secure backend.
  return false;
}

export function clearLocalAuthData(): void {
  localStorage.removeItem("customerId");
  localStorage.removeItem("customerEmail");
  localStorage.removeItem("customerFirstName");
  localStorage.removeItem("customerUsername");
  localStorage.removeItem("lastSessionCustomerId");
}
